<template>
  <div>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('g') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ educationOrCertification.startYear }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('h') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ educationOrCertification.endYear }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('i') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ educationOrCertification.institute }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('j') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ educationOrCertification.description }}
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    educationOrCertification: Object
  }
}
</script>


<i18n>
{
  "fr": {
    "g": "Année de début",
    "h": "Année de fin",
    "i": "Institut",
    "j": "Description"
  },
  "en": {
    "g": "Start year",
    "h": "End year",
    "i": "Institute",
    "j": "Description"
  }
}
</i18n>